<template>
    <el-select v-model="plan_id"
               placeholder="Select Plan"
               class="w-full"
               :loading="loading_plans"
               clearable
               @change="onChange">
        <el-option v-for="item in plans"
                   :key="item.id"
                   :label="item.name"
                   :value="item.id">
            <span>{{ item.name }}</span>
        </el-option>
    </el-select>
</template>

<script>

export default {
    props: {
        value: {
            type: Number,
            required: false,
        }
    },

    data() {
        return {
            plan_id: this.value,
            loading_plans: false,
            plans: []
        }
    },

    created() {
        this.getPlans()
    },

    methods: {
        onChange() {
            this.$emit('change', this.plan_id || null)
            this.$emit('input', this.plan_id || null)
        },

        getPlans() {
            this.loading_plans = true
            axios.get('/api/admin/plan', {
                params: {
                    reseller_id: [2132]
                }
            }).then(res => {
                this.plans = res.data
                this.loading_plans = false
            }).catch(err => {
                this.loading_plans = false
                this.$root.handleErrors(err.response)
            })
        },
    },

    watch: {
        value (value) {
            this.plan_id = value
        }
    }
}
</script>
